import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=7a55bf1e&"
import script from "./Detalhes.vue?vue&type=script&lang=js&"
export * from "./Detalhes.vue?vue&type=script&lang=js&"
import style0 from "./Detalhes.vue?vue&type=style&index=0&id=7a55bf1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports